module.exports = __webpack_public_path__ + "img/13.06d5a0ac.png";